module.exports = __webpack_public_path__ + "img/accessory_item_05.279a19a1.svg";